import { Button, FormControl, Modal, TextField } from "@mui/material";
import { FunctionComponent, useEffect } from "react";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import { SelectSede } from "../../../../components/selects/sede";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import useLoading from "../../../../hooks/useLoading";


export const GrupoMinisterioEdit: FunctionComponent = () => {

  const {
    goBack,
  } = useNav();

  const {
    id
  } = useParams();

  const { setMensagemSuccess, setMensagemError } = useErrorSuccess();
  const { startLoading, stopLoading, isLoading } = useLoading();

  const getMinisterioGrupo = async () => {
    let req = await api.get('ministerio/grupo/' + id);
    setValue('sede', req?.data?.sede);
    setValue('descricao', req?.data?.descricao);
    return;
  }

  const {
    register,
    watch,
    setValue,
    handleSubmit
  } = useForm<{ sede: number, descricao: string }>({
    defaultValues: {
      sede: null,
      descricao: null
    }
  });

  useEffect(() => {
    getMinisterioGrupo();
  }, [id])


  const put = handleSubmit(async (values) => {
    startLoading();
    try {
      await api.put('ministerio/grupo/'+id, values);
      setMensagemSuccess('Alterado com sucesso!');
      goBack()
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data?.mensagem || 'Erro ao tentar alterar ministério'))
    } finally {
      stopLoading();
    }
  })

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <SelectSede action={(action) => setValue('sede', action)} value={watch('sede')} />

          <FormControl sx={{ mt: 1 }} fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained" onClick={put} disable={isLoading}>Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
